import { render, staticRenderFns } from "./Page-Home.vue?vue&type=template&id=955fe7aa&scoped=true&"
import script from "./Page-Home.vue?vue&type=script&lang=js&"
export * from "./Page-Home.vue?vue&type=script&lang=js&"
import style0 from "./Page-Home.vue?vue&type=style&index=0&id=955fe7aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955fe7aa",
  null
  
)

export default component.exports